import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

const STORAGE_KEY = 'theme-preference';

@Injectable({providedIn: 'root'})
export class ThemeService {
  isDark$ = new BehaviorSubject<boolean>(localStorage.getItem(STORAGE_KEY) === 'dark');

  constructor() {
    if (this.isDark$.value) {
      document.documentElement.classList.add('dark');
    }
  }

  toggle(): void {
    const dark = !this.isDark$.value;
    this.isDark$.next(dark);
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
  }
}
